/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      hasIconSlot: false,
      hasLabelSlot: false,
      hasNumSlot: false,
      hasTopRightSlot: false
    };
  },
  mounted: function mounted() {
    // 判断slot是否存在
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
    this.$slots.num && (this.hasNumSlot = true);
    this.$slots.topRight && (this.hasTopRightSlot = true);
  }
};